/**
 * Featured Product - Vertical Thumbnail Height Synchronization
 * Syncs the height of vertical thumbnail slider with main product slider
 * Only applies for desktop (992px+) with vertical thumbnail layout
 */

class FeaturedProductThumbnailHeight {
  constructor() {
    this.observers = [];
    this.init();
  }

  init() {
    // Wait for images to load before initial sync
    if (document.readyState === 'complete') {
      this.syncHeights();
      this.setupIntersectionObserver();
    } else {
      window.addEventListener('load', () => {
        this.syncHeights();
        this.setupIntersectionObserver();
      });
    }

    // Also sync on resize (debounced)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.syncHeights(), 250);
    });
  }

  setupIntersectionObserver() {
    const productCarousels = document.querySelectorAll('.feature-product product-carousel.product-slider--thumbnail-left');

    productCarousels.forEach(carousel => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Element is visible, sync heights after a short delay
            setTimeout(() => this.syncHeightsForCarousel(carousel), 100);
          }
        });
      }, {
        root: null,
        threshold: 0.1
      });

      observer.observe(carousel);
      this.observers.push(observer);
    });
  }

  syncHeightsForCarousel(carousel) {
    if (window.innerWidth < 992) return;

    const mainSlider = carousel.querySelector('.product-main-slide-container');
    const thumbnailSlider = carousel.querySelector('.swiper-thumbnails .swiper-container');

    if (mainSlider && thumbnailSlider) {
      const mainHeight = mainSlider.offsetHeight;
      if (mainHeight > 0) {
        thumbnailSlider.style.height = `${mainHeight}px`;
      }
    }
  }

  syncHeights() {
    // Find all featured product sections with vertical thumbnails
    const productCarousels = document.querySelectorAll('.feature-product product-carousel.product-slider--thumbnail-left');

    productCarousels.forEach(carousel => {
      // Get the main slider container
      const mainSlider = carousel.querySelector('.product-main-slide-container');

      // Get the thumbnail slider container (vertical slider)
      const thumbnailSlider = carousel.querySelector('.swiper-thumbnails .swiper-container');

      if (mainSlider && thumbnailSlider) {
        // Below 992px: restore auto height
        if (window.innerWidth < 992) {
          thumbnailSlider.style.height = '';
          return;
        }

        // Desktop (992px and up): sync heights
        const mainHeight = mainSlider.offsetHeight;
        if (mainHeight > 0) {
          thumbnailSlider.style.height = `${mainHeight}px`;
        }
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FeaturedProductThumbnailHeight();
  });
} else {
  new FeaturedProductThumbnailHeight();
}
